import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-row align-items-center"
}
const _hoisted_2 = {
  key: 0,
  class: "me-2"
}
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "ms-1" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_11 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "d-flex float-start"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (_ctx.device)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_ctx.isAdmin || _ctx.isOperator)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (!_ctx.device.blockedAt)
                      ? _withDirectives((_openBlock(), _createElementBlock("button", {
                          key: 0,
                          title: _ctx.helper.trans('trader.status.active'),
                          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toggleBlock(_ctx.device, true)), ["prevent"])),
                          class: "btn btn-sm btn-outline-success"
                        }, _cache[2] || (_cache[2] = [
                          _createElementVNode("i", { class: "fa fa-circle-play" }, null, -1)
                        ]), 8, _hoisted_3)), [
                          [
                            _directive_b_tooltip,
                            void 0,
                            void 0,
                            { hover: true }
                          ]
                        ])
                      : _withDirectives((_openBlock(), _createElementBlock("button", {
                          key: 1,
                          title: _ctx.helper.trans('labels.traffic_blocked'),
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.toggleBlock(_ctx.device, false)), ["prevent"])),
                          class: "btn btn-sm btn-outline-warning"
                        }, _cache[3] || (_cache[3] = [
                          _createElementVNode("i", { class: "fa fa-circle-pause" }, null, -1)
                        ]), 8, _hoisted_4)), [
                          [
                            _directive_b_tooltip,
                            void 0,
                            void 0,
                            { hover: true }
                          ]
                        ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("i", {
                    title: _ctx.title,
                    style: {"font-size":"70%"},
                    class: _normalizeClass([{'text-success': _ctx.device.status === 'online', 'text-danger': _ctx.device.status === 'offline'}, "fa-solid fa-circle"])
                  }, null, 10, _hoisted_6), [
                    [
                      _directive_b_tooltip,
                      void 0,
                      void 0,
                      {
                        hover: true,
                        html: true
                      }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.device.name), 1),
                  _createVNode(_component_copy_button, {
                    class: "ms-1",
                    value: _ctx.copyTitle
                  }, null, 8, ["value"])
                ]),
                (_ctx.showId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _withDirectives((_openBlock(), _createElementBlock("small", {
                        class: "text-secondary",
                        title: _ctx.device.id
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.device.id.substr(0, 8)), 1)
                      ], 8, _hoisted_9)), [
                        [
                          _directive_b_tooltip,
                          void 0,
                          void 0,
                          { hover: true }
                        ]
                      ]),
                      _cache[4] || (_cache[4] = _createTextVNode()),
                      _createVNode(_component_copy_button, {
                        value: _ctx.device.id
                      }, null, 8, ["value"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.device?.deletedAt !== null)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_ctx.helper.trans('labels.deleted')), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, "n/a"))
      ])
    ]),
    _: 1
  }, 512))
}